import { render } from "./ResetPassword_modal.vue?vue&type=template&id=d4544352"
import script from "./ResetPassword_modal.vue?vue&type=script&lang=js"
export * from "./ResetPassword_modal.vue?vue&type=script&lang=js"

import "./ResetPassword_modal.vue?vue&type=style&index=0&id=d4544352&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__